import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import {GaTrackingEventCategory, GaTrackingEventName, GATrackingEventType} from '../../constants';

export class GATrackingBuyboxQuantityPickerInteractionEvent implements GATrackingEvent {

  constructor(private label: string) {
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.QuantityPickerInteraction;
  }

  getPayload(): GATrackingEventPayload {

    return {
      event: GaTrackingEventName.ChangeQuantity,
      label: this.label,
      gtmCustom: {
        category: GaTrackingEventCategory.Ecommerce
      }
    };
  }
}
